import { render } from "./bookmark_folder_edit.vue?vue&type=template&id=35c9eb34"
import script from "./bookmark_folder_edit.js?vue&type=script&lang=js"
export * from "./bookmark_folder_edit.js?vue&type=script&lang=js"

import "./bookmark_folder_edit.vue?vue&type=style&index=0&id=35c9eb34&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__